<template>
  <div class="indicador-ventas-datos">
    <b-row>
      <b-col cols="12" xl="12">  
        <app-data
          titulo="Información del Indicador"
          :datos="indicadorDatos">
        </app-data>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="12" xl="12">  
        <app-data
          titulo="Valores del Indicador"
          :datos="indicadorValores">
        </app-data>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="12" xl="12">  
        <app-data
          titulo="Valores del Indicador s/Reembolsos"
          :datos="indicadorValoresSinReembolsos">
        </app-data>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="12" xl="12">  
        <b-card header="Clientes">
          <b-table 
              class="registro clientes"
              responsive="sm" 
              :items="indicadorClientes" 
              :fields="fields">
            <template v-slot:cell(pjeParticipacion)="data">
              {{ data.item.pjeParticipacion | porcentaje }}
            </template>
          </b-table>
        </b-card>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="12" xl="12">  
        <b-card header="Objetivos Mensuales" v-if="indicadorObjetivosMensuales.length > 0">
          <b-table 
              class="registro objetivos-mensuales"
              responsive="sm" 
              :items="indicadorObjetivosMensuales" 
              :fields="objetivosMensualesFields">
            <template v-slot:cell(pjeObjetivo)="data">
              {{ data.item.pjeObjetivo | porcentaje }}
            </template>
          </b-table>
        </b-card>
      </b-col>
    </b-row>

    <div class="fixed-btn">
      <div class="data-goback-btn" @click.prevent="goBack">
          <i class="fa fa-undo fa-2x" aria-hidden="true"></i>
      </div>
    </div>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import Data from  '../shared/tableData.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'indicadorVentas/getField',
  mutationType: 'indicadorVentas/updateField',
});

export default {
  name: 'IndicadoresVentasDatos',
  components: {
    appData: Data,
    appMensaje: Mensaje,
  },
  mixins: [
    msjModal, 
  ],
  data: () => {
    return {
      indicadorId: 0,

      fields: [
        { 
          key: 'cliente',
        },
        { 
          key: 'pjeParticipacion',
          class: 'text-right',
        }
      ],

      objetivosMensualesFields: [
        { 
          key: 'mes',
        },
        { 
          key: 'pjeObjetivo',
          class: 'text-right',
        }
      ]     
    }
  },
  computed: {
    ...mapFields([
      'indicadorDatos',
      'indicadorValores',
      'indicadorValoresSinReembolsos',
      'indicadorClientes',
      'indicadorObjetivosMensuales'
    ]),
  },
  created() {
    this.indicadorId = this.$route.params.id;

    this.$store.dispatch('indicadorVentas/getDatos', this.indicadorId)
      .catch(error => this.showErrorMsj(error));
  },  
  methods: {
    goBack() {
      this.$router.push({ name: 'IndicadoresVentas' });
    },
  }
}
</script>

<style>
  .indicador-ventas-datos .registro.clientes td[aria-colindex="1"],
  .indicador-ventas-datos .registro.objetivos-mensuales td[aria-colindex="1"] {
    width: 80%;
  }
  .indicador-ventas-datos .registro.clientes td[aria-colindex="2"],
  .indicador-ventas-datos .registro.objetivos-mensuales td[aria-colindex="2"] {
    width: 20%;
  }
</style>